import React from "react"
import LineFood from "@assets/svg/line-food.svg"
import { IconProps } from "@define/icon"

const LineFoodIcon = (props: IconProps) => {
  return <LineFood style={props.style} width={props.width || 24} height={props.height || 15} />
}

export default LineFoodIcon
